import React, { useEffect, useState } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import swal from "sweetalert"
import { axiosbaseurl } from "configure"
import LoadingButton from "components/Common/LoadingButton"
import fetchRealData from "helpers/ClientDataReplacement"

const ClientEmailTemplates = ({
  client = {},
  setClientData,
  show,
  setShow,
  clientIds,
  setSelectForExport,
}) => {
  const [templates, setTemplates] = useState([])
  const [templates_data, setTemplatesData] = useState([])
  const [templateData, setTemplateData] = useState({})
  const [realData, setRealData] = useState({})
  const [view, setView] = useState(false)
  const [emailType, setEmailType] = useState("")
  const [loading, setLoading] = useState(false)
  const [loading2, setLoading2] = useState(false)

  useEffect(() => {
    if (!show) setClientData("")
  }, [show])

  useEffect(() => {
    const getEmailTemplates = async () => {
      try {
        const response = await axiosbaseurl.get("/email-template/active")
        if (response.data.success) {
          setTemplates(response.data.data)
          setTemplatesData(response.data.data)
        }
      } catch (error) {
        console.log(error)
      }
    }
    getEmailTemplates()
  }, [])

  // filter by email type
  useEffect(() => {
    if (emailType)
      setTemplates(templates_data.filter(t => t.deliveryType === emailType))
    else setTemplates(templates_data)
  }, [emailType])

  // sending instant emails to selected clients
  const handleSendMail = async (type) => {
    swal({
      title: "Are you sure?",
      text: "You really want to send email",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willDelete => {
      if (willDelete) {
        try {
          if (type)
            setLoading2(true)
          else
            setLoading(true)

          const request = {
            [`clientIds`]: client.id ? [client.id] : clientIds,
            templateId: templateData.id
          }

          // decides we are sending email to self
          if (type)
            request.type = type;

          // console.log("request", request)

          const { data } = await axiosbaseurl.post(
            `/client/send-email/multiple`,
            request
          )

          if (data.success) {
            setShow(false)
            setView(false)
            setClientData({})
            setSelectForExport([])

            swal("Email Sent Successfully!", {
              icon: "success",
            })
          }
        } catch (error) {
          console.log(error)
          const msg =
            error?.response?.data?.message ||
            error.message ||
            "Something went Wrong"
          swal(
            "",
            msg,
            msg.includes(
              "Client doesn't have any task related to this email template criteria."
            )
              ? "warning"
              : "error"
          )
        } finally {
          if (type)
            setLoading2(false)
          else
            setLoading(false)
        }
      }
    })
  }

  const emailTypeOptions = ["Normal", "Recurring", "Ad-hoc"]

  return (
    <>
      <Modal
        size="xl"
        fullscreen
        isOpen={show}
        toggle={() => setShow(!show)}
        centered={true}
      >
        <div className="modal-content">
          <ModalHeader className=" bg-primary">
            <div className="d-flex align-items-center justify-content-between w-100 px-4">
              <div>
                <h4 className="mb-0" style={{ color: "#d9ebed" }}>
                  {" "}
                  Email Templates
                  {client.clientName ? (
                    <span className="text-white"> for {client.clientName}</span>
                  ) : null}
                </h4>
              </div>
              <div>
                <div className="d-flex align-items-center justify-content-between  ">
                  <div>
                    <select
                      className="form-select"
                      value={emailType}
                      onChange={e => setEmailType(e.target.value)}
                    >
                      <option value="">All Types</option>
                      {emailTypeOptions.map(etype => (
                        <option value={etype} key={etype}>
                          {etype}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <button
                      type="button"
                      className="btn btn-danger ms-3"
                      onClick={() => setShow(!show)}
                    >
                      <i className="fa fa-times me-2"></i> Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <div className="px-4 mt-3">
              <div className="row">
                <div className="col-12">
                  <div
                    className="table-responsive table-header-height fixed-table-header"
                    style={{ maxHeight: "520px" }}
                  >
                    <table className="table table-bordered">
                      <thead className="table-primary">
                        <tr>
                          <th>Template Name</th>
                          <th>Subject</th>
                          <th>Email Type</th>
                          <th>Related To</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {templates?.map((template, i) => {
                          return (
                            <tr key={i}>
                              <td>{template.templateName}</td>
                              <td>
                                {clientIds?.length > 1 ? template?.subject : fetchRealData(template?.subject, client)}
                                {/* {template?.subject} */}
                              </td>
                              <td>{template.deliveryType}</td>
                              <td className="text-capitalize">
                                {template.relatedTo?.replace("-", " ") || "--"}
                              </td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setTemplateData(template)
                                    setView(true)
                                    setRealData(client)
                                  }}
                                  className={`btn btn-sm btn-primary`}
                                >
                                  <i className="fa fa-eye me-2"></i>
                                  View{" "}
                                </button>
                              </td>
                            </tr>
                          )
                        })}
                        {!templates?.length && (
                          <tr>
                            <th colSpan={4} className="text-danger text-center">
                              {" "}
                              Not Found!{" "}
                            </th>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      {/* view modal */}
      <Modal
        size="xl"
        isOpen={view}
        toggle={() => setView(!view)}
        centered={true}
      >
        <div className="modal-content">
          <ModalBody className="px-3">
            <div className="d-flex justify-content-between align-items-center pb-3 mb-4 border-bottom">
              <h5 className="text-capitalize mb-0"> Template Details </h5>
              <div>

                <LoadingButton
                  loading={loading2}
                  handler={() => handleSendMail("self")}
                  btnText="Send To Self"
                  btn="secondary"
                />

                <span className="ps-3">
                  <LoadingButton
                    loading={loading}
                    handler={() => handleSendMail()}
                    btnText="Send Email"
                  />
                </span>

                {/* <select onChange={(e) }>
                  <option value="">Filter by type</option>
                  {
                    emailTypeOptions.map(etype => {
                      <option value={etype}>etype</option>
                    })
                  }
                </select> */}

                <button
                  type="button"
                  onClick={() => setView(!view)}
                  className={`btn btn-danger ms-3`}
                >
                  <i className="fa fa-times me-2"></i>
                  Close
                </button>
              </div>
            </div>

            <div>
              <div className="row">
                {/* <div className="col-md-3 mb-3">
                  <label>Email Type</label>
                  <div className="form-control input-field view-field text-capitalize">
                    {templateData?.deliveryType || "--"}
                  </div>
                </div>
                <div className="col-md-3 mb-3">
                  <label>
                    {templateData?.deliveryType === "Recurring"
                      ? "Interval Days"
                      : "After Days"}
                  </label>
                  <div className="form-control input-field view-field text-capitalize">
                    {templateData[
                      templateData?.deliveryType === "Recurring"
                        ? "followUpDays"
                        : "afterDays"
                    ] || "--"}
                  </div>
                </div>
                <div className="col-md-3 mb-3">
                  <label>Trigger</label>
                  <div className="form-control input-field view-field text-capitalize">
                    {templateData?.relatedTo || "--"}
                  </div>
                </div>
                <div className="col-md-3 mb-3">
                  <label className="text-capitalize">
                    {templateData?.relatedTo?.replace("-", " ")}
                  </label>
                  <div className="form-control input-field view-field text-capitalize">
                    {templateData?.emailStatus || "--"}
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <label>Service Name</label>
                  <div className="form-control input-field view-field text-capitalize">
                    {templateData?.serviceId
                      ? templateData?.serviceName?.serviceName
                      : "--"}
                  </div>
                </div> */}
                <div className="col-12 mb-3">
                  <label>Template Name</label>
                  <div className="form-control input-field view-field text-capitalize">
                    {templateData?.templateName || "--"}
                  </div>
                </div>
                <div className="col-12 mb-3">
                  <label>Subject</label>
                  <div className="form-control input-field view-field text-capitalize">
                    {clientIds?.length > 1 ? templateData?.subject : fetchRealData(templateData?.subject, realData) || "--"}

                  </div>
                </div>

                <div className="col-md-12 mb-4">
                  <label>Body</label>

                  <div
                    className="p-3 border bg-light"
                    dangerouslySetInnerHTML={{
                      __html:
                        clientIds?.length > 1 ? templateData?.body : fetchRealData(templateData?.body, realData) ||
                          "<div></div>",
                    }}
                  />
                </div>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  )
}

export default ClientEmailTemplates
